var moment = require("moment");

(function ($, undefined) {
    "use strict"

    moment.locale("hu")

    $(document).ready(function () {
        var options = {
            locale: moment.locale(),
            icons: {
                time: "icon",
                date: "icon-io-calendar",
                up: "icon-io-circle-up",
                down: "icon-io-circle-down",
                previous: "icon-io-circle-left",
                next: "icon-io-circle-right"
            },
            sideBySide: true,
            calendarWeeks: true
        }

        $("input.datetime").each(function () {
            $(this).datetimepicker($.extend({
                format: "YYYY-MM-DD HH:mm"
            }, options))
        })

        $("input.date").each(function () {
            $(this).datetimepicker($.extend({
                format: "YYYY-MM-DD"
            }, options))
        })

        $("input.time").each(function () {
            $(this).datetimepicker($.extend({
                format: "HH:mm"
            }, options))
        })

        $("div.inline-datetime").each(function () {
            $(this).datetimepicker($.extend({
                inline: true,
                format: "YYYY-MM-DD HH:mm",
                defaultDate: $(this).data("default-date")
            }, options))
        })
        $("div.inline-date").each(function () {
            $(this).datetimepicker($.extend({
                inline: true,
                format: "YYYY-MM-DD",
                defaultDate: $(this).data("default-date")
            }, options))
        })
        $("div.inline-time").each(function () {
            $(this).datetimepicker($.extend({
                inline: true,
                format: "HH:mm",
                defaultDate: $(this).data("default-date")
            }, options))
        })

        $("select[multiple]").multiselect()

        $(".js-btn-print").click(function () {
            window.print()
        })
    })
}(jQuery))



//////////////////
// WEBPACK FOOTER
// ./vendor/vi-kon/laravel-admin/src/resources/assets/js/script.js
// module id = 323
// module chunks = 0